import { Box, Paper, CircularProgress, Fade, Typography } from "@mui/material";

const LoadingOverlay = ({ loading, children, label = "Loading..." }) => {
    return (
        <Box position="relative" aria-busy={loading ? "true" : "false"}>
            {/* Content (blurred when loading) */}
            <Box
                sx={{
                    filter: loading ? "blur(2px)" : "none",
                    pointerEvents: loading ? "none" : "auto",
                    userSelect: loading ? "none" : "auto",
                    transition: "filter 200ms ease",
                }}
            >
                {children}
            </Box>

            {/* Overlay */}
            <Fade in={loading} unmountOnExit>
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "grid",
                        placeItems: "center",
                        // subtle dim
                        background:
                            "linear-gradient(rgba(255,255,255,0.35), rgba(255,255,255,0.35))",
                        // keep events from passing through
                        pointerEvents: "auto",
                        zIndex: 2,
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            px: 2.5,
                            py: 2,
                            borderRadius: 2,
                            minHeight: 100,
                            minWidth: 100,
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            justifyContent: "center",
                        }}
                    >
                        <CircularProgress size={22} thickness={5} />
                        <Typography variant="body2" fontWeight={600}>
                            {label}
                        </Typography>
                    </Paper>
                </Box>
            </Fade>
        </Box>
    );
};

export { LoadingOverlay }
